<template>
    <v-card class="app-screen-bg pl-2 pl-md-10 skills-page">
        <div class="skills-page__scroll">
            <div class="skills-title-pill-wrap">
                <span class="skills-title-pill">{{ $t('pokedex.skills.titlePill') }}</span>
            </div>

            <SkillListTable
                v-if="skills.length > 0"
                :items="skills"
                @open-detail="openDetail"
            />
        </div>

        <SkillDetailPopup v-model="detailOpen" :skill="selectedSkill" :known-obstacle-types="knownObstacleTypes"/>
    </v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import SkillListTable from "@/components/pokedex/SkillListTable";
    import SkillDetailPopup from "@/components/pokedex/SkillDetailPopup";
    import {API_ENTRYPOINT} from "@/config/entrypoint";

    export default {
        components: {SkillListTable, SkillDetailPopup},
        data() {
            return {
                skills: [],
                selectedSkill: null,
                detailOpen: false,
                trainerItem: null,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
            }),
            // Trainer::getKnownObstacleTypes() - "You know, this skill
            // breaks..." v SkillDetailPopup.vue.
            knownObstacleTypes() {
                return this.trainerItem ? this.trainerItem.knownObstacleTypes : [];
            },
        },
        created() {
            this.loadData();
            this.loadTrainer(this.user.id).then((data) => {
                this.trainerItem = data;
            });
        },
        methods: {
            ...mapActions({
                fetchObject: 'pokemon/fetchObject',
                loadTrainer: 'trainer/loadItem',
            }),
            loadData() {
                let url = new URL("api/pokemon_type_skills", API_ENTRYPOINT);
                let obj = {url: url, method: 'GET'}
                url.searchParams.set("itemsPerPage", 1000);
                this.fetchObject(obj).then(
                    (data) => {
                        this.skills = data['member'];
                    }
                );
            },
            openDetail(skill) {
                this.selectedSkill = skill;
                this.detailOpen = true;
            },
        },
    }
</script>

<style scoped>
    /* "height:100%" misto "100vh" (viz komentar u ".new-shell-ui .v-main" v App.vue). */
    .skills-page {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .skills-page__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding-right: 8px;
    }

    /* Sticky primo uvnitr scrollovaci oblasti, vzor Toplist.vue - viz
       claude/architecture/frontend.md bod 8. */
    .skills-title-pill-wrap {
        position: sticky;
        top: 0;
        z-index: 3;
        display: flex;
        justify-content: center;
        padding: 8px 0;
        background: transparent;
    }

    .skills-title-pill {
        display: inline-block;
        background: rgba(0, 0, 0, .7);
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        padding: 6px 20px;
        border-radius: 20px;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .6);
    }
</style>
